export default {"src":"/_next/static/media/twitter.97c65758.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};